module.exports = __webpack_public_path__ + "img/sound_off.3837685a.svg";